<div class="row align-items-end">
  <div class="col-3">
    <usimweb-searchbar (searchBarChanged)="searchBarChanged($any($event))"></usimweb-searchbar>
  </div>

  <div class="col-9 d-none d-lg-block">
    <!-- <usimweb-fav-filter (favFilterChanged)="favFilterChanged($any($event))"></usimweb-fav-filter> -->
    <usimweb-menu-filter (menuFilterChanged)="menuFilterChanged($any($event))"></usimweb-menu-filter>
  </div>

  <!-- <div class="d-md-block d-lg-none" style="margin-top: 30px; padding-left: 0px">
      <button (click)="filterFavouriteChangedEvent()" style="line-height: 14px !important" mat-icon-button>
        <mat-icon *ngIf="!filterFavourite" style="font-size: 28px">star_border</mat-icon>
        <mat-icon *ngIf="filterFavourite" style="font-size: 28px">star</mat-icon>
      </button>

      <app-menu-filter (menuFilterChanged)="menuFilterChanged($event)"></app-menu-filter>
    </div> -->
</div>
